export enum Error {
  General = 'Something went wrong.',
  UserRoleCheck = "Enter an existing End User's email address to make them the owner of this project. If the customer does not have an existing Live Optics account, they will be automatically registered as an End user.",
  EmailCheck = 'Something went wrong while checking email.',
  RegisterNewUser = 'Something went wrong while registering new user.',
  VerifyDell = 'Something went wrong while verifying owner as Dell.',
  VerifyEndUser = 'Something went wrong while verifying owner as an end user.',
  SetDeal = 'Something went wrong while setting deal ID.',
  SetOpportunity = 'Something went wrong while setting opportunity.',
}
